export default __webpack_public_path__ + "static/media/Inter-BoldItalic.30352075.woff2";